import React from 'react';
import PropTypes from 'prop-types';

import DataCard from '../../../common/card/DataCard';

export const CustomerDetails = ({ data = {} }) => {
  const { id, firstName, lastName, email, phoneNumber, creditAmount } = data;

  const details = [
    { label: 'Customer ID', data: id, link: true, route: 'customers', id },
    { label: 'Customer Name', data: `${firstName} ${lastName}` },
    { label: 'Email', data: email },
    { label: 'Phone Number', data: phoneNumber },
    { label: 'Total Credits', data: Number(creditAmount).toFixed(2), currency: true },
  ];

  return <DataCard title="Customer Details" cardData={details} />;
};

CustomerDetails.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    creditAmount: PropTypes.number,
    id: PropTypes.number,
  }),
};
